<template>
  <div>
    <v-row class="ma-2">
      <v-col cols="12" md="6" class="mb-4">
        <v-row dense>
          <v-col>
            <h4>{{ $t("savings.economic") }}</h4>
          </v-col>
        </v-row>

        <v-row dense class="ma-2">
          <v-col cols="12">
            <v-icon color="grey"> mdi-weather-sunny-off</v-icon><v-icon color="grey">mdi-weather-sunset-up</v-icon> {{ $t("savings.originalExpensesToday") }}: <b>{{ originalExpensesToday }} Kč</b>
          </v-col>
          <v-col cols="12">
            <v-icon color="grey"> mdi-weather-sunny-off</v-icon><v-icon color="grey">mdi-weather-sunset-down</v-icon> {{ $t("savings.originalExpensesYesterday") }}: <b>{{ originalExpensesYesterday }} Kč</b>
          </v-col>
        </v-row>

        <v-row dense class="ma-2">
          <v-col cols="12">
            <v-icon color="amber"> mdi-solar-power</v-icon> <v-icon color="amber">mdi-weather-sunset-up</v-icon> {{ $t("savings.currentSavingsToday") }}: <b>{{ currentSavingsToday }} Kč</b>
          </v-col>
          <v-col cols="12">
            <v-icon color="amber"> mdi-solar-power</v-icon> <v-icon color="amber">mdi-weather-sunset-down</v-icon> {{ $t("savings.currentSavingsYesterday") }}: <b>{{ currentSavingsYesterday }} Kč</b>
          </v-col>
        </v-row>

        <v-row dense class="ma-2">
          <v-col cols="12">
            <v-icon color="purple"> mdi-transmission-tower-import</v-icon> <v-icon color="purple">mdi-weather-sunset-up</v-icon>{{ $t("savings.currentExpensesToday") }}: <b>{{ currentExpensesToday }} Kč</b>
          </v-col>
          <v-col cols="12">
            <v-icon color="purple"> mdi-transmission-tower-import</v-icon> <v-icon color="purple">mdi-weather-sunset-down</v-icon> {{ $t("savings.currentExpensesYesterday") }}: <b>{{ currentExpensesYesterday }} Kč</b>
          </v-col>
        </v-row>

        <v-row dense class="ma-2">
          <v-col cols="12">
            <v-icon color="blue"> mdi-transmission-tower-export</v-icon> <v-icon color="blue">mdi-weather-sunset-up</v-icon> {{ $t("savings.sellToday") }}: <b>{{ sellToday }} Kč</b>
          </v-col>
          <v-col cols="12">
            <v-icon color="blue"> mdi-transmission-tower-export</v-icon> <v-icon color="blue">mdi-weather-sunset-down</v-icon> {{ $t("savings.sellYesterday") }}: <b>{{ sellYesterday }} Kč</b>
          </v-col>
        </v-row>

        <v-row dense class="ma-2">
          <v-col cols="12">
            <v-icon color="light-green">mdi-piggy-bank-outline</v-icon> <v-icon color="light-green">mdi-weather-sunset-up</v-icon> {{ $t("savings.fveToday") }}: <b>{{ fveToday }} Kč</b>
          </v-col>
          <v-col cols="12">
            <v-icon color="light-green">mdi-piggy-bank-outline</v-icon> <v-icon color="light-green">mdi-weather-sunset-down</v-icon> {{ $t("savings.fveYesterday") }}: <b>{{ fveYesterday }} Kč</b>
          </v-col>
        </v-row>

        <br />
        <br />

        <v-row dense>
          <v-col>
            <h4>{{ $t("savings.environmental") }}</h4>
          </v-col>
        </v-row>

        <v-row dense class="ma-2">
          <v-col cols="12">
            <v-icon color="grey"> mdi-weather-snowy-heavy</v-icon> {{ $t("savings.co2") }}: <b>{{ CO2Saved }} {{ $t("savings.tons") }}</b>
          </v-col>
          <v-col cols="12">
            <v-icon color="blue-grey"> mdi-cart</v-icon> {{ $t("savings.coal") }}: <b>{{ coalSaved }} {{ $t("savings.tons") }}</b>
          </v-col>
          <v-col cols="12">
            <v-icon color="green"> mdi-forest</v-icon> {{ $t("savings.trees") }}: <b> {{ treesSaved }}</b>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="3" class="mb-4">
        <AnySparkLineChart :header="$t('savings.currentSavingsChartYesterday')" :data="currentSavingsChartYesterday" :max="currentSavingsChartYesterdayMax" :min="currentSavingsChartYesterdayMin" :colors="['#AEEA00', '#8BC34A', '#4CAF50']" />
        <AnySparkLineChart :header="$t('savings.currentExpensesChartYesterday')" :data="currentExpensesChartYesterday" :max="currentExpensesChartYesterdayMax" :min="currentExpensesChartYesterdayMin" :colors="['#03A9F4', '#00BCD4', '#009688']" />
        <AnySparkLineChart :header="$t('savings.originalExpensesChartYesterday')" :data="originalExpensesChartYesterday" :max="originalExpensesChartYesterdayMax" :min="originalExpensesChartYesterdayMin" :colors="['#D50000', '#EF5350', '#F44336']" />
      </v-col>
      <v-col cols="12" md="3" class="mb-4">
        <AnySparkLineChart :header="$t('savings.currentSavingsChartToday')" :data="currentSavingsChartToday" :max="currentSavingsChartTodayMax" :min="currentSavingsChartTodayMin" :colors="['#AEEA00', '#8BC34A', '#4CAF50']" />
        <AnySparkLineChart :header="$t('savings.currentExpensesChartToday')" :data="currentExpensesChartToday" :max="currentExpensesChartTodayMax" :min="currentExpensesChartTodayMin" :colors="['#03A9F4', '#00BCD4', '#009688']" />
        <AnySparkLineChart :header="$t('savings.originalExpensesChartToday')" :data="originalExpensesChartToday" :max="originalExpensesChartTodayMax" :min="originalExpensesChartTodayMin" :colors="['#D50000', '#EF5350', '#F44336']" />
      </v-col>
    </v-row>

    <br />
    <br />
    <br />

    <v-row justify="end">
      <v-col cols="6" md="2">
        <v-text-field :label="$t('savings.priceSell')" v-model.number="priceSell" suffix="Kč" @input="recalculate()" @change="saveTarif()"></v-text-field>
      </v-col>

      <v-col cols="6" md="2">
        <v-text-field :label="$t('savings.price')" v-model.number="price" suffix="Kč" @input="recalculate()" @change="saveTarif()"></v-text-field>
      </v-col>
    </v-row>
    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";

import AnySparkLineChart from "../../components/charts/AnySparkLineChart.vue";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "Savings",
  components: {
    AnySparkLineChart,
    UpgradeCore,
  },
  data() {
    return {
      timer: null,

      sellToday: 0,
      sellYesterday: 0,

      fveToday: 0,
      fveYesterday: 0,

      originalExpensesToday: 0,
      currentExpensesToday: 0,
      currentSavingsToday: 0,
      originalExpensesYesterday: 0,
      currentExpensesYesterday: 0,
      currentSavingsYesterday: 0,

      originalExpensesChartToday: [],
      currentExpensesChartToday: [],
      currentSavingsChartToday: [],
      originalExpensesChartYesterday: [],
      currentExpensesChartYesterday: [],
      currentSavingsChartYesterday: [],

      originalExpensesChartTodayMin: 0,
      originalExpensesChartTodayMax: 0,
      currentExpensesChartTodayMin: 0,
      currentExpensesChartTodayMax: 0,
      currentSavingsChartTodayMin: 0,
      currentSavingsChartTodayMax: 0,
      originalExpensesChartYesterdayMin: 0,
      originalExpensesChartYesterdayMax: 0,
      currentExpensesChartYesterdayMin: 0,
      currentExpensesChartYesterdayMax: 0,
      currentSavingsChartYesterdayMin: 0,
      currentSavingsChartYesterdayMax: 0,

      coalSaved: 0,
      CO2Saved: 0,
      treesSaved: 0,

      price: 10, // Kč / kWh
      priceSell: 2, // Kč / kWh

      dataMain: null,
      dataChart: null,
      //dataPlaces: null,
    };
  },
  created() {
    this.getMainData();

    this.getChartYesterday();
    this.getChartToday();

    this.loadTarif();
    this.recalculate();
  },
  mounted() {
    this.pollData();
  },
  methods: {
    loadTarif() {
      if (localStorage.getItem("tarif") !== null) {
        this.price = localStorage.getItem("tarif");
      }
      if (localStorage.getItem("tarifSell") !== null) {
        this.priceSell = localStorage.getItem("tarifSell");
      }
    },
    saveTarif() {
      localStorage.setItem("tarifSell", this.priceSell);
      localStorage.setItem("tarif", this.price);
    },
    recalculate() {
      this.sellToday = this.dataMain.grid.energyOverflowsToday * this.priceSell;
      this.sellYesterday = this.dataMain.grid.energyOverflowsYesterday * this.priceSell;

      this.originalExpensesToday = this.dataMain.load.energyToday * this.price;
      this.currentExpensesToday = (this.dataMain.grid.energyConsumptionToday / this.dataMain.load.energyToday) * this.originalExpensesToday;
      this.currentSavingsToday = this.originalExpensesToday - this.currentExpensesToday;
      this.originalExpensesYesterday = this.dataMain.load.energyYesterday * this.price;
      this.currentExpensesYesterday = (this.dataMain.grid.energyConsumptionYesterday / this.dataMain.load.energyYesterday) * this.originalExpensesYesterday;
      this.currentSavingsYesterday = this.originalExpensesYesterday - this.currentExpensesYesterday;

      let producedEnergy = this.dataMain.load.energyToday - this.dataMain.grid.energyConsumptionToday + this.dataMain.load.energyYesterday - this.dataMain.grid.energyConsumptionYesterday + this.dataMain.grid.energyOverflowsToday + this.dataMain.grid.energyOverflowsYesterday;

      this.coalSaved = producedEnergy / 2460;
      this.CO2Saved = (producedEnergy * 1.011511) / 1000;
      this.treesSaved = producedEnergy * 0.0117;

      this.fveToday = this.sellToday + this.currentSavingsToday;
      this.fveYesterday = this.sellYesterday + this.currentSavingsYesterday;

      this.sellToday = Math.round(this.sellToday * 100) / 100;
      this.sellYesterday = Math.round(this.sellYesterday * 100) / 100;

      this.fveToday = Math.round(this.fveToday * 100) / 100;
      this.fveYesterday = Math.round(this.fveYesterday * 100) / 100;

      this.originalExpensesToday = Math.round(this.originalExpensesToday * 100) / 100;
      this.currentExpensesToday = Math.round(this.currentExpensesToday * 100) / 100;
      this.currentSavingsToday = Math.round(this.currentSavingsToday * 100) / 100;
      this.originalExpensesYesterday = Math.round(this.originalExpensesYesterday * 100) / 100;
      this.currentExpensesYesterday = Math.round(this.currentExpensesYesterday * 100) / 100;
      this.currentSavingsYesterday = Math.round(this.currentSavingsYesterday * 100) / 100;
      this.coalSaved = Math.round(this.coalSaved * 100000) / 100000;
      this.CO2Saved = Math.round(this.CO2Saved * 100000) / 100000;
      this.treesSaved = Math.round(this.treesSaved * 100000) / 100000;
    },
    pollData() {
      this.timer = setInterval(() => {
        this.getMainData();
        this.getChartYesterday();
        this.getChartToday();
        //this.getPlacesData();
      }, 3000);
    },
    processChartData(data, when) {
      let difference;

      if (when === "Today") {
        this.originalExpensesChartToday = [];
        this.currentExpensesChartToday = [];
        this.currentSavingsChartToday = [];

        for (let index = 0; index < this.dataChart.labels.length; index++) {
          this.originalExpensesChartToday.push(this.dataChart.load[index] * this.price);
          this.currentExpensesChartToday.push(this.dataChart.load[index] != 0 ? (this.dataChart.grid[index] / this.dataChart.load[index]) * this.originalExpensesChartToday[index] : 0);
          difference = this.originalExpensesChartToday[index] - this.currentExpensesChartToday[index];
          this.currentSavingsChartToday.push(difference > 0 ? difference : 0);
        }

        this.originalExpensesChartTodayMin = Math.round(Math.min(...this.originalExpensesChartToday) * 100) / 100;
        this.originalExpensesChartTodayMax = Math.round(Math.max(...this.originalExpensesChartToday) * 100) / 100;
        this.currentExpensesChartTodayMin = Math.round(Math.min(...this.currentExpensesChartToday) * 100) / 100;
        this.currentExpensesChartTodayMax = Math.round(Math.max(...this.currentExpensesChartToday) * 100) / 100;
        this.currentSavingsChartTodayMin = Math.round(Math.min(...this.currentSavingsChartToday) * 100) / 100;
        this.currentSavingsChartTodayMax = Math.round(Math.max(...this.currentSavingsChartToday) * 100) / 100;
      } else if (when === "Yesterday") {
        this.originalExpensesChartYesterday = [];
        this.currentExpensesChartYesterday = [];
        this.currentSavingsChartYesterday = [];

        for (let index = 0; index < this.dataChart.labels.length; index++) {
          this.originalExpensesChartYesterday.push(this.dataChart.load[index] * this.price);
          this.currentExpensesChartYesterday.push(this.dataChart.load[index] != 0 ? (this.dataChart.grid[index] / this.dataChart.load[index]) * this.originalExpensesChartYesterday[index] : 0);
          difference = this.originalExpensesChartYesterday[index] - this.currentExpensesChartYesterday[index];
          this.currentSavingsChartYesterday.push(difference > 0 ? difference : 0);
        }

        this.originalExpensesChartYesterdayMin = Math.round(Math.min(...this.originalExpensesChartYesterday) * 100) / 100;
        this.originalExpensesChartYesterdayMax = Math.round(Math.max(...this.originalExpensesChartYesterday) * 100) / 100;
        this.currentExpensesChartYesterdayMin = Math.round(Math.min(...this.currentExpensesChartYesterday) * 100) / 100;
        this.currentExpensesChartYesterdayMax = Math.round(Math.max(...this.currentExpensesChartYesterday) * 100) / 100;
        this.currentSavingsChartYesterdayMin = Math.round(Math.min(...this.currentSavingsChartYesterday) * 100) / 100;
        this.currentSavingsChartYesterdayMax = Math.round(Math.max(...this.currentSavingsChartYesterday) * 100) / 100;
      }
    },
    getMainData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("main"), null, null, "GET")
        .then((data) => {
          this.dataMain = data;

          this.recalculate();
        })
        .catch((error) => {
          this.dataMain = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    formatDate(dateTime) {
      return dateTime.substr(0, 4) + dateTime.substr(5, 2) + dateTime.substr(8, 2);
    },
    formatStart(dateTime) {
      return this.formatDate(dateTime) + "0000";
    },
    formatStop(dateTime) {
      return this.formatDate(dateTime) + "2359";
    },
    getTodayDate() {
      return new Date().toISOString();
    },
    getYesterdayDate() {
      return new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toISOString();
    },
    getTomorrowDate() {
      return new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString();
    },
    getChartData(dt1, dt2, when) {
      let parameters = "?time=H" + "&type=E" + "&limit=24" + "&dt1=" + dt1 + "&dt2=" + dt2;

      ServiceClient.dataCore(ServiceClient.getAPIUrl("chart"), null, parameters, "GET")
        .then((data) => {
          this.dataChart = data;

          this.processChartData(data, when);
        })
        .catch((error) => {
          this.dataChart = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    getChartYesterday() {
      this.getChartData(this.formatStart(this.getYesterdayDate()), this.formatStop(this.getYesterdayDate()), "Yesterday");
    },
    getChartToday() {
      this.getChartData(this.formatStart(this.getTodayDate()), this.formatStop(this.getTodayDate()), "Today");
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  destroyed() {},
};
</script>

<style scoped></style>
